<!--
 * @Description: 派单权树状组件
 * @Author: fengal
 * @Date: 2024-06-17 18:01:35
-->
<template>
  <div class="dispatch-tree">
    <div class="hspList">
      <div class="title">
        <span>医院列表</span>
      </div>
      <div class="hsp" v-for="(item, index) in hospitalDepartmentDOList" :key="item.hospitalId" :class="item.hospitalId == curHsp.hospitalId ? 'activeHsp' : 'commonHsp'" @click.stop="handleClickHsp(item)">
        <el-checkbox v-model="item.hospitalSelectFlag" disabled :true-label="1" :false-label="0"></el-checkbox>
        <span>
          {{item.hospitalName}}
        </span>
      </div>
    </div>
    <div class="deptList">
      <div class="title">
        <span>科室列表</span>
      </div>
      <el-tree :data="curDeptList" show-checkbox default-expand-all node-key="id" ref="deptTree" highlight-current :props="defaultDeptProps" :default-checked-keys="checkedDeptKeys">
      </el-tree>
    </div>
    <div class="serviceList">
      <div class="title">
        <span>服务列表</span>
      </div>
      <el-tree :data="curServiceList" show-checkbox default-expand-all node-key="id" ref="serviceTree" highlight-current :props="defaultServiceProps" :default-checked-keys="checkedServiceKeys">
      </el-tree>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DispatchTree',

  props: ["hospitalDepartmentDOList", "hospitalHserviceDOList"],

  data() {
    return {
      curHsp: {},
      curDeptList: [],
      curServiceList: [],
      checkedDeptKeys: [],
      checkedServiceKeys: [],
      defaultDeptProps: {
        children: 'department2List',
        label: 'name',
        disabled: ()=>{
          return true
        }
      },
      defaultServiceProps: {
        children: 'hserivceModeList',
        label: 'name',
        disabled: ()=>{
          return true
        }
      },
    }
  },

  watch: {
    hospitalDepartmentDOList: {
      handler(newVal, _oldVal) {
        this.handleClickHsp(newVal[0])
      },
      deep: true,
      immediate: true,
    },

    hospitalHserviceDOList: {
      handler(newVal, _oldVal) {
        if (newVal.length) {
          this.curServiceList = newVal[0].hserviceModeDTOList
        }
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    // 切换当前选中医院
    handleClickHsp(item) {
      this.curHsp = item
      this.curDeptList = this.curHsp.department1List || []

      this.getSelDeptKeys()
      this.$nextTick(() => {
        if (!this.checkedDeptKeys.length && this.$refs.deptTree) {
          this.$refs.deptTree.setCheckedKeys([])
        } else {
          console.warn('this.$refs.deptTree is undefined');
        }
      });

      this.hospitalHserviceDOList.forEach(hsp => {
        if (hsp.hospitalId === item.hospitalId) {
          this.curServiceList = hsp.hserviceModeDTOList || []
          this.getSelServiceKeys()
          this.$nextTick(() => {
            if (!this.checkedServiceKeys.length && this.$refs.serviceTree) {
              this.$refs.serviceTree.setCheckedKeys([])
            } else {
              console.warn('this.$refs.serviceTree is undefined');
            }
          });
          return false
        }
      });
    },

    // 获取当前选中医院科室的所有key
    getSelDeptKeys() {
      this.checkedDeptKeys = [];
      this.curDeptList.forEach((item) => {
        if (item.selectFlag) this.checkedDeptKeys.push(item.id)
        item.department2List.forEach((dept) => {
          if (dept.selectFlag) this.checkedDeptKeys.push(dept.id)
        })
      })
    },

    // 获取当前选中科室下的所有服务key
    getSelServiceKeys() {
      this.checkedServiceKeys = [];
      this.curServiceList.forEach((item) => {
        if (item.selectFlag) this.checkedServiceKeys.push(item.id)
        item.hserivceModeList.forEach((svc) => {
          if (svc.selectFlag) this.checkedServiceKeys.push(svc.id)
        })
      })
    }
  }
}
</script>

<style>
.dispatch-tree {
  position: relative;
  max-height: 464px;
  overflow-y: auto;
	display: flex;
  background: #fff;
}
.dispatch-tree .hspList,
.dispatch-tree .deptList,
.dispatch-tree .serviceList {
  max-height: 360px;
  overflow-y: auto;
  padding: 15px;
  border: 1px solid #e7e7e7;
  flex: 1;
}
.dispatch-tree .title {
  position: relative;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-weight: bold;
  color: #5b5b5b;
  font-size: 16px;
  margin-bottom: 10px;
}
.dispatch-tree .hsp {
  padding: 10px 15px;
}
.dispatch-tree .activeHsp {
  background: #f4f7ff;
  cursor: pointer;
}
.dispatch-tree .commonHsp {
  background: #fff;
  cursor: pointer;
}
.dispatch-tree .el-tree {
  padding: 0 10px;
  position: relative;
  cursor: default;
  background: #fff;
  color: #606266;
}
.el-tree-node__label {
  text-overflow:ellipsis;/*省略号 */
  white-space:nowrap;/*溢出时不换行 */
  overflow:hidden;/*溢出时隐藏 */
}
</style>


// WEBPACK FOOTER //
// src/components/instmng/components/dispatchpvg/DispatchTree.vue